import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EpagoService } from 'src/app/services/epago.service';
import { v4 as uuidv4 } from 'uuid';

@Component({ standalone: false,
  selector: 'app-form-vtex',
  templateUrl: './form-vtex.component.html',
  styleUrls: ['./form-vtex.component.css']
})
export class FormVtexComponent {
  myForm: FormGroup;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly epagoService: EpagoService,
  ) {
    this.myForm = this.formBuilder.group({
      'card': ['4242424242424242'],
      'validThru': ['12/30'],
      'cvc2': ['123'],
      'currency': ['PEN'],
      'amount': [10.50],
    });
  }

  makeid(length: number) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  generatePayment() {

    let pmToken = "Tarjeta-Oh";
    var successUrl = "https://webhook.site/234bc6bf-518e-41ff-820a-4d07fa7a34af";

    let vtexPaymentBody = {
      "reference": uuidv4(),
      "transactionId": uuidv4(),
      "paymentId": 'vtx-sim-' + this.makeid(17),
      "paymentMethod": pmToken,
      "paymentMethodCustomCode": null,
      "merchantName": "irredcomercio",
      "orderId": new Date().getTime(),
      "card": {
        "number": null,
        "holder": null,
        "expiration": {
          "month": null,
          "year": null
        },
        "csc": null,
        "document": null
      },
      "value": this.myForm.get('amount')?.value,
      "currency": this.myForm.get('currency')?.value, // "currency": "USD",
      "installments": 1,
      "deviceFingerprint": "12ade389087fe",
      "ipAddress": null,
      "miniCart": {
        "buyer": {
          "id": "c1245228-1c68-11e6-94ac-0afa86a846a5",
          "firstName": "Juan",
          "lastName": "Quispe",
          "document": "01234567890",
          "documentType": "CPF",
          "corporateName": null,
          "tradeName": null,
          "corporateDocument": null,
          "isCorporate": false,
          "email": "accept@accept.com",
          "phone": "+51016194810",
          "createdDate": null
        },
        "shippingAddress": {
          "country": "PE",
          "street": "Av La Molina Cdra",
          "number": "3",
          "complement": "Ate",
          "neighborhood": "La Molina",
          "postalCode": "15012",
          "city": "Lima",
          "state": "Lima"
        },
        "billingAddress": {
          "country": "PE",
          "street": "Manzana R, Lote 16, urbanización los nisperos",
          "number": "",
          "complement": "",
          "neighborhood": "San Martin de Porres",
          "postalCode": "",
          "city": "Lima",
          "state": "Lima"
        },
        "items": [
          {
            "id": "132981",
            "name": "My First Product",
            "price": 25,
            "quantity": 2,
            "discount": 0,
            "deliveryType": null
          },
          {
            "id": "132982",
            "name": "My Second Product",
            "price": 125,
            "quantity": 1,
            "discount": -100,
            "deliveryType": null
          }
        ],
        "shippingValue": 0,
        "taxValue": 0
      },
      "url": "https://qa.pagoweb.pe/simular.html",
      "callbackUrl": successUrl,
      "returnUrl": successUrl
    };

    this.epagoService.generateVtexPayment('QA', 'c5da785c644f4133aed96fdb17d039af', '35f3e4ff91d648d43b274eb70a6a6c829e656f566a1a74', vtexPaymentBody).subscribe(response => {
      console.log('response', JSON.stringify(response));
      window.location.href = response.paymentUrl;
    });

  }


}
